import {
  FETCH_DESTINATION_DETAIL_SUCCEEDED,
  SELECT_DESTINATION_TYPE,
  FETCH_DESTINATION_TYPE_SUCCEEDED_WITHOUR_PREFILL,
  UPDATE_DESTINATION_REQUESTED,
  FETCH_ALL_DESTINATION_TYPE_SUCCEEDED
} from './edit.action';
import * as _ from 'lodash';

export const edit = (state = { fetched: false, data: { destinationTypes: [] } }, action) => {
  switch (action.type) {
    case FETCH_DESTINATION_DETAIL_SUCCEEDED:
      return _.assign({}, state, {
        fetched: true,
        data: action.data
      });

    case SELECT_DESTINATION_TYPE:
      return _.assign({}, state, {
        data: _.assign({}, state.data, {
          destinationType: action.data
        })
      });

    case FETCH_DESTINATION_TYPE_SUCCEEDED_WITHOUR_PREFILL:
      return _.assign({}, state, { fetched: true, data: action.data });

    case UPDATE_DESTINATION_REQUESTED:
      return _.assign({}, state, { fetched: true });

    case FETCH_ALL_DESTINATION_TYPE_SUCCEEDED:
      return _.assign({}, state, {
        DestinationTypes: action.data,
        data: _.assign(state.data, { destination_type: _.find(action.data, item => item.getId() === (state as any).data.destination_type_id) })
      });

    default:
      return state;
  }
};
